import type {RepScoreService, RepScoreResponse} from '../../../infrastructure/services/RepScoreService';

export interface GetUserRepScoreParams {
    userId: string;
}

export class GetUserRepScoreUseCase {
    constructor(private readonly repScoreService: RepScoreService) {
    }

    async execute(params: GetUserRepScoreParams): Promise<RepScoreResponse> {
        try {
            return await this.repScoreService.getUserRepScore(params.userId);
        } catch (error: any) {
            if (error.response?.status === 404) {
                throw new Error('RepScore not found for user. Complete profile setup to generate score.');
            }
            throw error;
        }
    }
}